import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SlidersHorizontal } from "lucide-react";

import { track } from "@/lib/api";
import { labelFor } from "@/lib/options";
import { StyleRowCard } from "@/components/cards";
import { Button, Card, IconCircle, ScreenHeader, Spinner } from "@/components/kit";
import { Page } from "@/components/layout";
import { useApp } from "@/store";

export default function Recommendations() {
  const { profile, hasProfile, recs, recsError: error, refreshRecs: load, topSlugs } = useApp();
  const navigate = useNavigate();
  useEffect(() => {
    track("recommendations_viewed", { source: "list" });
  }, []);
  return (
    <div data-testid="recommendations-screen">
      <ScreenHeader testId="recommendations-back" label="Your top 5" right={<IconCircle testId="recommendations-edit-profile" icon={SlidersHorizontal} label="Edit profile" onClick={() => navigate("/edit-profile")} />} />
      <Page className="flex flex-col gap-4 pb-12">
        <h1 data-testid="recommendations-title" className="t-h1">STYLES MADE FOR YOU.</h1>
        <p className="t-body">
          {hasProfile
            ? `Based on ${[labelFor("hair_type", profile.hair_type), labelFor("length", profile.length), profile.face_shape ? `${labelFor("face_shape", profile.face_shape)} face` : null].filter((x) => x && x !== "—").join(" · ")}`
            : "Add your hair details for sharper matches."}
        </p>
        {error ? (
          <Card>
            <p data-testid="recommendations-error" className="t-body">{error}</p>
            <Button testId="recommendations-retry" title="Retry" variant="outline" onClick={load} className="mt-3" />
          </Card>
        ) : !recs ? (
          <Spinner className="mx-auto mt-8" />
        ) : (
          <div className="flex flex-col gap-3">
            {recs.map((r, i) => (
              <div key={r.style.slug} className="animate-fade-up" style={{ animationDelay: `${i * 80}ms` }}>
                <StyleRowCard testId={`recommendation-${i + 1}`} rank={i + 1} style={r.style} explanation={r.explanation} faceNote={r.face_note} forYou={topSlugs.has(r.style.slug)} onClick={() => navigate(`/style/${r.style.slug}`)} />
              </div>
            ))}
          </div>
        )}
        <p className="t-caption">AI styling suggestions are estimates, not professional or medical assessments. Every style can work for anyone — these are simply your closest matches.</p>
        <Button testId="recommendations-explore-all" title="Explore all 40 styles" variant="outline" onClick={() => navigate("/explore")} />
      </Page>
    </div>
  );
}
